import { Loading } from 'JBSrc/constants';

// MODAL EVENTS
(function($){
	//Club requests modal
	$('#clubReviewModal').on('show.bs.modal', function (event) {
		let button = $(event.relatedTarget);
		let action = button.data('action');
		let status = '';
		let modal = $(this);
		modal.find('.modal-body').html(Loading.request);
		modal.addClass('modal--loading');
		modal.find('.modal-title').html('');
		modal.find('.modal-status').html('');

	  	$.get(action, function(html){
			if(button.data('title')){
	 			modal.find('.modal-title').html(button.data('title'));
			}
	 		modal.find('.modal-body').html(html);

			if(modal.find('.card__collectionLog--status').length){
				modal.find('.card__collectionLog--status').appendTo('#clubReviewStatus');
				$('#clubReviewStatus').removeClass('d-none');
			}
			modal.removeClass('modal--loading');
	  	});
  	});

	//Venue modal
	$('#venueModal').on('show.bs.modal', function (event) {
		let button = $(event.relatedTarget);
		let action = button.data('action');
		let status = '';
		let modal = $(this);
		modal.find('.modal-inner').html(Loading.venue);
		modal.addClass('modal--loading');

	  	$.get(action, function(html){
	 		modal.find('.modal-inner').html(html);
			modal.removeClass('modal--loading');
	  	});
  	});

	// Login modal
	$('#loginModal').on('show.bs.modal', function (event) {
		let button = $(event.relatedTarget);
		let redirect = button.data('redirect');
		let modal = $(this);

		if(redirect !== undefined){
			modal.find('input[name="redirect"]').val(redirect);
		}
  	});
})(jQuery);

jQuery($ => {
	// Update My Interests Modal (User profile page)
	const $myInterestModal = $('#myInterestsModal');
	if($myInterestModal.find('.alert').length){
		$myInterestModal.modal('show');
	}
	const $loginModal = $('#loginModal');
	if($loginModal.find('.alert').length){
		$loginModal.modal('show');
	}
});
